import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=5c5de4d8&scoped=true&"
import script from "./forgot-password.vue?vue&type=script&lang=ts&"
export * from "./forgot-password.vue?vue&type=script&lang=ts&"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=5c5de4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5de4d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDialog,VForm,VRow,VTextField})
